import slick from 'slick-carousel';

jQuery( '.js-plans-slider' ).slick( {
	rows: 0,
	slidesToShow: 3,
	infinite: false,
	dots: true,
	prevArrow: '<button type="button" class="slick-prev"><svg width="12" height="21" viewBox="0 0 12 21" xmlns="http://www.w3.org/2000/svg"><path d="m10.5 1.5-9 9 9 9" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
	nextArrow: '<button type="button" class="slick-next"><svg width="12" height="21" viewBox="0 0 12 21" xmlns="http://www.w3.org/2000/svg"><path d="m1.5 19.5 9-9-9-9" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
	responsive: [
		{
			breakpoint: 992,
			settings: {
				arrows: false,
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 576,
			settings: {
				arrows: false,
				slidesToShow: 1.15,
			}
		}
	]
} );
